module.exports = __webpack_public_path__ + "static/1-a5c7358b94c0dfeb67458363a45e8c2a.png";